
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/podatek-od-nieruchomosci",
      function () {
        return require("private-next-pages/podatek-od-nieruchomosci/index.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/podatek-od-nieruchomosci"])
      });
    }
  